import styled from "styled-components";
import { Form as UnformForm } from "@unform/web";

export const Screen = styled.div`
  min-height: 100vh;
  display: grid;
  grid-template-columns: 1.05fr 1fr;

  @media (max-width: 900px) {
    grid-template-columns: 1fr;
  }
`;

export const FormPane = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 48px 40px;
  background: var(--auth-bg-cream);
`;

export const FormCard = styled.div`
  width: 100%;
  max-width: 388px;
`;

export const Header = styled.div`
  margin-bottom: 34px;

  h2 {
    font-family: "Bricolage Grotesque", sans-serif;
    font-weight: 800;
    font-size: 32px;
    letter-spacing: -0.03em;
    line-height: 1.05;
    margin: 0 0 8px;
    color: var(--auth-text-primary);
  }

  p {
    font-size: 15.5px;
    color: var(--auth-text-secondary);
    margin: 0;
  }
`;

export const Form = styled(UnformForm)`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const LabelLink = styled.a`
  font-size: 13px;
  font-weight: 600;
  color: var(--auth-link);
  cursor: pointer;

  &:hover {
    color: var(--auth-link-hover);
  }
`;

export const FormError = styled.div`
  min-height: 20px;
  font-size: 13.5px;
  font-weight: 500;
  color: var(--auth-accent);
`;

export const PrimaryButton = styled.button`
  margin-top: 8px;
  background: var(--auth-accent);
  color: #fff;
  font-family: inherit;
  font-size: 16px;
  font-weight: 700;
  padding: 15px;
  border: none;
  border-radius: 999px;
  cursor: pointer;
  box-shadow: 0 10px 26px rgba(255, 122, 0, 0.3);
  transition: filter 0.15s ease, opacity 0.15s ease;

  &:hover:enabled {
    filter: brightness(1.05);
  }

  &:disabled {
    cursor: default;
    opacity: 0.7;
  }
`;

export const FootNote = styled.p`
  text-align: center;
  font-size: 14.5px;
  color: var(--auth-text-secondary);
  margin: 28px 0 0;

  a {
    font-weight: 700;
    color: var(--auth-link);
    cursor: pointer;
  }

  a:hover {
    color: var(--auth-link-hover);
  }
`;

export const ConfirmationCard = styled.div`
  background: #fff;
  border: 1px solid var(--auth-card-border);
  border-radius: 16px;
  padding: 26px 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
`;

export const ConfirmationIcon = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 52px;
  height: 52px;
  border-radius: 50%;
  background: var(--auth-soft-tint);
  color: var(--auth-accent);
  font-size: 24px;
  font-weight: 800;
  margin-bottom: 16px;
`;

export const ConfirmationTitle = styled.div`
  font-family: "Bricolage Grotesque", sans-serif;
  font-weight: 700;
  font-size: 19px;
  margin-bottom: 8px;
  color: var(--auth-text-primary);
`;

export const ConfirmationText = styled.p`
  font-size: 14.5px;
  line-height: 1.55;
  color: var(--auth-text-secondary);
  margin: 0;
`;
